export default __webpack_public_path__ + "static/media/archmage-(f-p).15e0be12.png";